import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'details-skeleton-base',
  templateUrl: 'details-skeleton-base.component.html',
})
export class DetailsSkeletonBaseComponent implements OnInit {
  @Input() counts = 0;

  constructor() {}

  ngOnInit() {}
}
